import { render, staticRenderFns } from "./VTaskControl.vue?vue&type=template&id=088e1cfc&"
import script from "./VTaskControl.vue?vue&type=script&lang=ts&"
export * from "./VTaskControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports